const ArrowIcon = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    className={className}
    width='16'
    height='12'
    viewBox='0 0 16 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.25 0.75L9.193 1.808L12.628 5.25H0.5V6.75H12.628L9.185 10.192L10.25 11.25L15.5 6L10.25 0.75Z'
      fill='currentColor'
    />
  </svg>
);

export default ArrowIcon;
